module.exports = __webpack_public_path__ + "img/icon-logout.6bc6200a.svg";